export const ADD_EXAM_SUMMARY = 'EXAM_SUMMARY';
export const CLEAR_EXAM_SUMMARY = 'CATEGORY_SUMMARY_QUESTIONS_SUCCESS';


